<template>
  <v-col cols="12" md="md">
    <v-row>
      <div><b>{{$t('display/elevator:workload-statistic.overbooked')}}</b> : {{ item.firstDayOverbooked }}</div>
    </v-row>
    <v-row>
      <div><b>{{$t('display/elevator:workload-statistic.no-workload-on')}}</b> : {{ item.firstDayNoWorkload }}</div>
    </v-row>
    <v-row>
      <div><b>{{$t('display/elevator:workload-statistic.average-workload')}}</b> : {{ item.avgWorkload }}</div>
    </v-row>
    <v-row>
      <div><b>{{$t('display/elevator:workload-statistic.strongest-workload')}}</b> : {{ getStrongestWorkload() }} %</div>
    </v-row>
    <v-row>
      <div><b>{{$t('display/elevator:workload-statistic.strongest-advert-workload')}}</b> : {{ item.mostWorkloadAdValue }}</div>
    </v-row>
    <v-row>
      <div><b>{{$t('display/elevator:workload-statistic.most-workload-value')}}</b> : {{ item.mostWorkloadValue }} %</div>
    </v-row>
    <v-row>
      <div><b>{{$t('display/elevator:workload-statistic.least-workload-on')}}</b> : {{ item.leastWorkloadDate }}</div>
    </v-row>
    <v-row>
      <div><b>{{$t('display/elevator:workload-statistic.least-workload-value')}}</b> : {{ item.leastWorkloadValue }} %</div>
    </v-row>
    <v-row>
      <div><b>{{$t('display/elevator:workload-statistic.statistic-generated-at')}}</b> : {{ item.calculatedAt }}</div>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: "StatisticField",
  props: {
    item: Object,
    md: String
  },
  methods: {
    getStrongestWorkload() {
      return this.item.mostWorkloadAd == null ? '' : this.item.mostWorkloadAd.name;
    }
  }
}
</script>
